// eslint-disable-next-line no-restricted-imports -- TODO: legacy styled-components (baseline)
import styled from 'styled-components/macro';

export const WidgetComment = styled.div`
    margin: 0 15px;

    font-weight: 600;
    font-size: 0.7em;
    letter-spacing: 0.5px;

    text-align: center;
    text-transform: uppercase;
`;
